import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'react-string-format';
import { translateResourceString } from '../../../util/translationUtility';

class Article extends React.Component {
    render() {
        const { Link, Title, Description, onClick, DocumentType, DocumentTypeConstant, DisplayDate } = this.props;
        let colorClass = "";
        let displayDate = DisplayDate;
        // See Common.Constants.SearchPage.DocumentTypes
        switch (DocumentTypeConstant) {
            case "Industry":
            case "Solution":
                colorClass = "--bg-green";
                displayDate = '';
                break;
            case "Blog":
            case "Event":
            case "Resource":
            case "Press Release":
            case "Video":
                colorClass = "--bg-teal"
                break;
            default: //General   
                colorClass = "--bg-cool-gray"
                break;
        }

        const updateUrl = () => window.location.href = Link;

        const onArticleClick = (e) => {
            e.preventDefault();
            onClick().then(() => {
                updateUrl();
            }).catch((error) => {
                console.log(error);
                updateUrl();
            })
        }

        const linkTitle = format(translateResourceString("/Search/ReadArticleTitle"), Title);

        return (
            <div className="article neo-center-preview">
                <a href={Link}
                    className="neo-center-preview__image-link"
                    onClick={onArticleClick}
                    aria-label={linkTitle}>
                    <div className={`neo-center-preview__label neo-center-preview__label${colorClass}`}>
                        {DocumentType}
                    </div>
                    <div className="neo-center-preview__body">
                        <div className="neo-center-preview__info">
                            <h5 className="neo-center-preview__title">{Title}</h5>
                            <div className="neo-center-preview__date">{displayDate || (<span>&nbsp;</span>)}</div>
                            <div className="neo-center-preview__text"><div className="js-truncate">{Description}</div></div>
                        </div>
                        <span className="neo-center-preview__link">
                            {translateResourceString("/Search/ReadArticle")}</span>
                    </div>
                </a>
            </div>
        );
    }
}

Article.propType = {
    Link: PropTypes.string,
    Title: PropTypes.string,
    Description: PropTypes.string,
    onClick: PropTypes.func,
    DocumentType: PropTypes.string,
    DocumentTypeConstant: PropTypes.string
};

export default Article;